import React from 'react';
import { useAuthUser } from '@crema/hooks/AuthHooks';
import { Formik } from 'formik';
import * as yup from 'yup';
import PersonalInfoForm from './PersonalInfoForm';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { putDataApi } from '@crema/hooks/APIHooks';
import { useInfoViewActionsContext } from '@crema/context/AppContextProvider/InfoViewContextProvider';

const validationSchema = yup.object({
  email: yup.string().email('Invalid email format').required('Required'),
});
const PersonalInfo = () => {
  const { user } = useAuthUser();
  const infoViewActionsContext = useInfoViewActionsContext();
  return (
    <Box
      sx={{
        position: 'relative',
        maxWidth: 550,
      }}
    >
      <Formik
        validateOnBlur={true}
        initialValues={{
          ...user,
          photoURL: user.photoURL
            ? user.photoURL
            : '/assets/images/placeholder.jpg',
        }}
        validationSchema={validationSchema}
        onSubmit={async (data, { setSubmitting }) => {
          const newData = {
            ...data
          };
          try {
            setSubmitting(true);
            //TODO Api Call here to save user info
            await putDataApi('/account', infoViewActionsContext, newData);
            infoViewActionsContext.fetchSuccess();
            infoViewActionsContext.showMessage(
              'Updated successfully!'
            );
          } catch (error) {
            infoViewActionsContext.fetchError(error.message);
          } finally {
            setSubmitting(false);
          }

        }}
      >
        {({ values, setFieldValue }) => {
          return (
            <PersonalInfoForm values={values} setFieldValue={setFieldValue} />
          );
        }}
      </Formik>
    </Box>
  );
};

export default PersonalInfo;

PersonalInfo.propTypes = {
  setFieldValue: PropTypes.func,
  values: PropTypes.string,
};
